import { DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { MODAL_TITLE, MODAL_DESCRIPTION } from '../constants'

export function CreatePostModalHeader() {
  return (
    <DialogHeader>
      <DialogTitle className="text-2xl font-bold text-center">{MODAL_TITLE}</DialogTitle>
      <p className="text-center text-gray-600">{MODAL_DESCRIPTION}</p>
    </DialogHeader>
  )
}
